module.exports = __webpack_public_path__ + "static/img/zhangpeng.e795e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhangpeng.png
// module id = pP3p
// module chunks = 21